/**
 * StepHeader Component
 * Tüm wizard adımlarında kullanılan ortak başlık komponenti
 */

import React from 'react';
import './StepHeader.css';

export interface StepHeaderProps {
    title: string;
    subtitle?: string;
    icon?: string; // Google Material Icon name (e.g. 'photo_camera')
    className?: string;
}

export const StepHeader: React.FC<StepHeaderProps> = ({
    title,
    subtitle,
    icon,
    className = ''
}) => {
    return (
        <div className={`step-header ${className}`}>
            {icon && (
                <span className="material-icons step-header__icon">{icon}</span>
            )}
            <h3 className="step-header__title">{title}</h3>
            {subtitle && (
                <p className="step-header__subtitle">{subtitle}</p>
            )}
        </div>
    );
};

export default StepHeader;
